import React from 'react';
import PropTypes from 'prop-types';
import { SpinnerStyled } from './styles';

function SpinnerLogo(props) {
  const {
    spinnerState = true,
    strokePrimary = '#00daaf',
    strokeSecondary = '#080833',
    background,
  } = props;
  if (!spinnerState) return null;

  return (
    <SpinnerStyled background={background}>
      <div className="loader">
        <svg version="1.1" viewBox="0 0 1920 1080" xmlSpace="preserve">
          <path
            stroke={strokePrimary}
            id="path01"
            className="path"
            d="M1089.1,641.5H655.6V235.6h405.9v405.9V743c0,56,45.4,101.5,101.5,101.5h0 c56,0,101.5-45.4,101.5-101.5v0c0-56-45.4-101.5-101.5-101.5H1089.1"
          />
          <path
            stroke={strokeSecondary}
            id="path02"
            className="path"
            d="M1061.5,207.6v433.9V743c0,56,45.4,101.5,101.5,101.5h0c56,0,101.5-45.4,101.5-101.5v0 c0-56-45.4-101.5-101.5-101.5H655.6V235.6h432.9"
          />
        </svg>
      </div>
    </SpinnerStyled>
  );
}

SpinnerLogo.propTypes = {
  spinnerState: PropTypes.bool,
  strokePrimary: PropTypes.string,
  strokeSecondary: PropTypes.string,
  background: PropTypes.string,
};

export default React.memo(SpinnerLogo);
